import type PlayClient from '@empathybroker/tsclient-play'
import type { Auth } from '@empathybroker/tsclient-play/dist/models/auth'
import type { LoginCredentials } from '@empathybroker/tsclient-play/dist/models/login-credentials'
import type { PlayResponse } from '@empathybroker/tsclient-play/dist/models/play-response'

import type { ActionContext } from 'vuex'

import type { ActionClass, AuthState } from '../../../models'
import type { StorageService } from '../../../services'

import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

import { AUTH_CONSTS } from '../../auth/auth.consts'

export class LoginAction implements ActionClass {
  static async execute(
    this: void,
    { commit }: ActionContext<AuthState, any>,
    payload: { credentials: LoginCredentials; keepLoggedIn: boolean },
  ): Promise<PlayResponse> {
    const playClient: PlayClient = CONTAINER.get<() => PlayClient>(TYPES.PlayClient)()
    try {
      const playResponse: PlayResponse = await playClient.login(payload.credentials)
      const playResponseData = playResponse.data as Auth
      const token = playResponseData.accessToken
      const refreshToken = playResponseData.refreshToken
      const keepLoggedIn = payload.keepLoggedIn || false
      commit(AUTH_CONSTS.mutations.setState, {
        token,
        refreshToken,
        keepLoggedIn,
      })
      const storageService: StorageService = CONTAINER.get<StorageService>(TYPES.StorageService)
      storageService.setItem(AUTH_CONSTS.storage.token, token)
      storageService.setItem(AUTH_CONSTS.storage.refreshToken, refreshToken)
      storageService.setItem(AUTH_CONSTS.storage.keepLoggedIn, keepLoggedIn.toString())
      return playResponse
    } catch (error) {
      throw error
    }
  }
}
